import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '../styles/variables';
import { ZIndex } from '../constants';
// Overlay が重なっても壊れないよう、参照カウントで最初の表示時に body スクロールをロックし最後の非表示時に復元する
let overlayCount = 0;
let originalBodyOverflow = '';
export const Overlay = ({ children, background, top, classObject, extendBackgroundToBrowserEdges, }) => {
    React.useEffect(() => {
        if (overlayCount === 0) {
            originalBodyOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
        overlayCount++;
        return () => {
            overlayCount--;
            if (overlayCount === 0) {
                document.body.style.overflow = originalBodyOverflow;
            }
        };
    }, []);
    const styles = StyleSheet.create({
        overlay: {
            position: 'fixed',
            backgroundColor: background || Colors.PrimaryLighter,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: ZIndex.Overlay,
            top: top || 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
    });
    return (React.createElement("div", { className: css(styles.overlay, classObject) },
        children,
        extendBackgroundToBrowserEdges && (React.createElement(React.Fragment, null,
            React.createElement("div", { "aria-hidden": true, className: css(browserEdgeStyles.edge, browserEdgeStyles.top) }),
            React.createElement("div", { "aria-hidden": true, className: css(browserEdgeStyles.edge, browserEdgeStyles.bottom) })))));
};
// iPhoneで全画面の背景色がブラウザ上下へ反映されない場合に、上下端の小さな固定要素から色を伝える。
// 実機で反映を確認した12pxを使い、操作を妨げず、オーバーレイと同時に取り外す。
const browserEdgeStyles = StyleSheet.create({
    edge: {
        position: 'fixed',
        left: 0,
        right: 0,
        height: 12,
        backgroundColor: 'inherit',
        pointerEvents: 'none',
    },
    top: {
        top: 0,
    },
    bottom: {
        bottom: 0,
    },
});
